var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ba1ed07f423a1048a163f6e8142d818dfdc61874"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mable-onboarding-app@mable-therapy"]={id:"ba1ed07f423a1048a163f6e8142d818dfdc61874"};
      